// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1Lgci","paramInput":"JobSimulator_paramInput__gQ4Tk","input":"JobSimulator_input__1CUYg"};